import { Navigate, Outlet } from 'react-router-dom';
import { useAccount } from '@src/hooks/useAccount';

export function AuthenticatedRoutes() {
  const { account } = useAccount();

  return account?.id ? <Navigate to="/" replace /> : <Outlet />;
}
